export default __webpack_public_path__ + "static/cta-right-bg-c22846982fba4fe05d6b525cd139cf3b.png";